module.exports = __webpack_public_path__ + "static/img/club-evnet-02.5b30dd3.jpg";